import { useCallback, useEffect } from "react";
import ChatMpProvider from "@/core/data-provider/data-mp/chat/chat-mp-provider";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useAppSelector from "@/core/helpers/useAppSelector";
import { IS_DEV } from "@/domains/main/constants/other.ts";
import {
  chatIsActiveSelector,
  chatIsEnabledSelector,
  chatIsOpenSelector,
  setChatEnable,
  setChatOpen,
  setFastMessage,
} from "@/domains/chat/slice";
import KeyCode from "@/assets/constants/key-code";

export default function useKeyboardEvent() {
  const dispatch = useAppDispatch();
  const isActive = useAppSelector(chatIsActiveSelector);
  const isEnabled = useAppSelector(chatIsEnabledSelector);
  const isOpen = useAppSelector(chatIsOpenSelector);

  const handleKeyDown = useCallback(
    (e) => {
      if (
        ![
          KeyCode.UP_ARROW,
          KeyCode.DOWN_ARROW,
          KeyCode.PAGE_UP,
          KeyCode.PAGE_DOWN,
          KeyCode.ESCAPE,
        ].includes(e.keyCode)
      ) {
        return;
      }

      if (!isActive) {
        return;
      }

      const chatList = document.getElementById("chat-list");

      switch (e.keyCode) {
        case KeyCode.PAGE_UP:
          e.preventDefault();
          if (chatList) {
            chatList.scrollTop -= 15;
          }
          break;
        case KeyCode.PAGE_DOWN:
          e.preventDefault();
          if (chatList) {
            chatList.scrollTop += 15;
          }
          break;
        case KeyCode.ESCAPE:
          e.preventDefault();
          dispatch(setChatOpen(false));

          // Вызываем mp.invoke для последнего сообщения
          if (!IS_DEV) {
            mp.invoke("setLastMessage", new Date().getTime());
          }
          break;
        default:
          break;
      }
    },
    [dispatch, isActive, isEnabled, isOpen],
  );

  useEffect(() => {
    if (!isOpen) {
      dispatch(setChatEnable(false));
      dispatch(setFastMessage(false));
      ChatMpProvider.inputDisable();
    }
  }, [dispatch, isOpen]);

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  });
}
